const appRecommendation = {
  applicationRate: Drupal.t('Application rate'),
  frequencyPerYear: Drupal.t('Application frequency'),
  intendedApplication: Drupal.t('Intended application'),
  subCropLink: Drupal.t('Crop details'),
  timeOfApplication: Drupal.t('Time of application'),
};

export default appRecommendation;
